const HANDLEBARS_PATTERN = new RegExp('{{(.+?)}}', 'g');

export default class JavascriptTemplatedScript {
  private templated: string;
  private extracted: boolean;
  private _parameterized: string;
  private _javascripts: string[];

  constructor(templated: string) {
    this.templated = templated.replace(/\s+/g, ' ').trim();
    this.extracted = false;
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    this._parameterized = null;
    this._javascripts = [];
  }

  get javascripts() {
    if (!this.extracted) {
      this.extract();
    }

    return this._javascripts;
  }

  get parameterized() {
    if (!this.extracted) {
      this.extract();
    }

    return this._parameterized;
  }

  evaluate(values: (string | number | boolean | Record<any, any>)[]) {
    if (!this.extracted) {
      this.extract();
    }

    if (values.length !== this.javascripts.length) {
      throw new Error(
        `Invalid number of values. Received ${values.length} values but expected ${
          this.javascripts.length
        } values for scripts ${JSON.stringify(this.javascripts)}`,
      );
    }

    let result = this.parameterized;
    for (const [i, _javascript] of this.javascripts.entries()) {
      // convert undefined to null since undefined is not valid JSON
      result = result.replace(`"{{${i}}}"`, JSON.stringify(values[i] ?? null));
    }

    return result;
  }

  private extract() {
    let index = 0;
    this._parameterized = this.templated.replace(HANDLEBARS_PATTERN, () => {
      return `{{${index++}}}`;
    });

    // Explicitly add back the quotation mark of _parameterized which was eaten
    // by converting to string when we only have one item (without any interpolation) to replace.
    if (this._parameterized === '{{0}}') {
      this._parameterized = `"${this._parameterized}"`;
    }

    const matches = this.templated.matchAll(HANDLEBARS_PATTERN);

    for (const match of matches) {
      this._javascripts = [...this._javascripts, match[1].trim()];
    }

    this.extracted = true;
  }
}
